// 所有的模块进行统一处理 导出一个统一的方法 useStore 
import React from 'react'
// 动态路由
import { LayoutStore } from '@/store/Layout'
//登录
import { LoginStore } from '@/store/Login'
//首页
import { Home } from './Home'

import {DistrictStore} from '@/store/District'
import {SystemStore} from '@/store/System'
import {InterfaceStore} from '@/store/Interface'
import {EnterpriseStore} from '@/store/Enterprise'
import {UnitStore} from '@/store/Unit'
import {DeviceStore} from '@/store/Device'
import {DataStore} from '@/store/Data'
import {RoleStore} from '@/store/Role'
import {AuthorityStore} from '@/store/Authority'
import { VideoStore } from '@/store/Video'
import { DhspStore } from '@/store/Dhsp'

class RootStore {

    constructor() {
        this.LayoutStore = new LayoutStore()
        this.LoginStore = new LoginStore()
        this.home = new Home()
        this.SystemStore= new SystemStore()
        this.InterfaceStore= new InterfaceStore()
        this.DistrictStore= new DistrictStore()
        this.EnterpriseStore= new EnterpriseStore()
        this.UnitStore= new UnitStore()
        this.DeviceStore= new DeviceStore()
        this.DataStore= new DataStore()
        this.RoleStore=new RoleStore()
        this.AuthorityStore=new AuthorityStore()
        this.VideoStore=new VideoStore()
        this.DhspStore=new DhspStore()
    }
    
}

//实例化根store注入context
const rootStore = new RootStore()
const context = React.createContext(rootStore)
//导出useStore方
const useStore = () => React.useContext(context)
export { useStore }